"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var atoms = _interopRequireWildcard(require("./atoms"));

var bytes = _interopRequireWildcard(require("../helpers/byte-helpers"));

var _accessUnit = require("../parsers/container/ts/access-unit");

var _adts = require("../parsers/container/ts/adts");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Transmuxer =
/*#__PURE__*/
function () {
  function Transmuxer() {
    _classCallCheck(this, Transmuxer);

    this.currentOffset = 0;
    this.currentMediaSequence = 1;
    this.videoDecode = 0;
    this.audioDecode = 0;
    this.lastKeyFrame = undefined;
  }

  _createClass(Transmuxer, [{
    key: "setCurrentStream",
    value: function setCurrentStream(ts) {
      this.currentStream = ts;
      this.streamTypes = ts.tracks.map(function (track) {
        return track.streamType;
      });

      if (this.hasVideo) {
        this.videoTrack = this.currentStream.tracks.filter(function (track) {
          return track.streamType === 27;
        })[0];
        this.videoIterator = (0, _accessUnit.keyframeIterator)(this.videoTrack.units);
      }

      if (this.hasAudio) {
        this.audioTrack = this.currentStream.tracks.filter(function (track) {
          return track.streamType === 15;
        })[0];
        this.audioIterator = (0, _adts.durationIterator)(this.audioTrack.units);
      }
    }
  }, {
    key: "hasAudio",
    value: function hasAudio() {
      return this.streamTypes.includes(15);
    }
  }, {
    key: "hasVideo",
    value: function hasVideo() {
      return this.streamTypes.includes(27);
    }
  }, {
    key: "nextMoof",
    value: function nextMoof() {
      var result = {
        currentMediaSequence: this.currentMediaSequence++,
        tracks: []
      };
      var videoConfig = Object.assign({}, this.videoTrack);
      delete videoConfig.units;
      var videoSamples = this.videoIterator.next();

      if (videoSamples === undefined) {
        return undefined;
      } // console.log(videoSamples.map(s => s.nalusWithoutConfig.map(n => n.nal_unit_type)))
      /// Fake keyframe
      // if (videoSamples[0].isKeyFrame) {
      //   this.lastKeyFrame = videoSamples[0]
      // } else {
      //   if (this.lastKeyFrame) {
      //     this.lastKeyFrame.duration = 0
      //     videoSamples.unshift(this.lastKeyFrame)
      //   }
      // }


      videoConfig.samples = videoSamples;
      result.tracks.push(videoConfig);
      var first = videoConfig.samples[0];
      var last = videoConfig.samples.slice(-1)[0];
      var audioSamplesForChunk = [];
      audioSamplesForChunk = this.audioIterator.next(last.packet.pts);
      var audioConfig = Object.assign({}, this.audioTrack);

      if (audioSamplesForChunk.length > 0) {
        audioConfig.samples = audioSamplesForChunk;
        var firstSample = audioConfig.samples[0];

        if (firstSample) {
          audioConfig.sampleRate = firstSample.header.samplingRate;
          audioConfig.channelConfig = firstSample.header.channelConfig;
          audioConfig.profile = firstSample.header.profileMinusOne + 1;
          delete audioConfig.units;
          result.tracks.push(audioConfig);
        } else {
          result.tracks.push({
            samples: [],
            trackID: 2,
            streamType: 15
          });
        }
      } /// Build the moof so we know where it ends and the mdat should begin


      var x = atoms.moof(result);
      var y = atoms.build(x);
      this.currentOffset = y.length + 8; // videoConfig.samples.forEach(au => {
      //   console.log(result.currentMediaSequence, au.duration, au.nalus.map(n => n.nal_unit_type))
      // })
      // console.log(this.videoDecode, result.currentMediaSequence);

      result.tracks[0].offset = this.currentOffset;
      result.tracks[0].decode = this.videoDecode;
      this.videoDecode += videoConfig.samples.reduce(function (a, c) {
        return a + c.duration;
      }, 0); // console.log(this.videoDecode);

      if (audioSamplesForChunk.length > 0) {
        // bump the offset so the audio track knows where to start
        this.currentOffset += videoConfig.samples.reduce(function (a, c) {
          return a + c.length;
        }, 0);
        result.tracks[1].offset = this.currentOffset;
        result.tracks[1].decode = this.audioDecode;
        this.audioDecode += audioConfig.samples.reduce(function (a, c) {
          return a + c.duration;
        }, 0);
      }

      return result;
    }
  }, {
    key: "build",
    value: function build() {
      var result = [];
      this.currentMediaSequence--;

      while (1) {
        var moof = this.nextMoof(); // console.log(moof);

        if (moof === undefined) {
          break;
        }

        result.push(moof);
      }

      return result;
    }
  }, {
    key: "buildInitializationSegment",
    value: function buildInitializationSegment(moof) {
      var result = [];
      result.push(atoms.ftyp());
      result.push(atoms.moov(moof));
      result = result.map(function (a) {
        return atoms.build(a);
      });
      return bytes.concatenate.apply(bytes, [Uint8Array].concat(_toConsumableArray(result)));
    }
  }, {
    key: "buildMediaSegment",
    value: function buildMediaSegment(moofs) {
      var result = [];
      moofs.forEach(function (moof) {
        result.push(atoms.moof(moof));
        result.push(atoms.mdat(moof));
      });
      result = result.map(function (a) {
        return atoms.build(a);
      });
      return bytes.concatenate.apply(bytes, [Uint8Array].concat(_toConsumableArray(result)));
    }
  }]);

  return Transmuxer;
}();

var _default = Transmuxer;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/transmuxing/transmuxer.js
// module id = 205
// module chunks = 0